import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { ChallengeBattleShipService, DefaultConfBattleBoat, PlacedShip, ShipData, ShipTypeObj } from 'src/app/gamification/command-center/services/challenge-battle-ship.service';

@Component({
  selector: 'cv-battle-boat-challenge',
  templateUrl: './battle-boat-challenge.component.html',
  styleUrls: ['./battle-boat-challenge.component.scss'],
  providers: [ChallengeBattleShipService] // providing service at the component level
})
export class BattleBoatChallengeComponent implements OnInit, OnDestroy {

  placedShips: PlacedShip[] = [];

  @Input() selectedInvites = [];
  @Input() wagerAmount = 0;
  @Input() gameType = 0;
  @Input() selectedStartDate = null;
  @Input() selectedInterval = null;
  @Input() confirmingChallenge = false;
  @Output() setCreatingBattle: EventEmitter<any> = new EventEmitter<any>();
  @Output() goBack: EventEmitter<any> = new EventEmitter<any>();
  @Output() setDefaultValuesAfterSaveBattleBoat: EventEmitter<any> = new EventEmitter<any>();
  @Output() updateShowInviteConfirmation: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() onAcceptChallenge: EventEmitter<any> = new EventEmitter<any>();

  private subscriptions = new Subscription();
  resetBoardTrigger = false

  constructor(private challengeBattleBoatService: ChallengeBattleShipService) { }

  resetBoard(): void {
    this.challengeBattleBoatService.setInitialData();
    this.resetBoardTrigger = !this.resetBoardTrigger; // Toggle to trigger change detection
  }
  
  ngOnInit(): void {
    this.subscriptions.add(this.challengeBattleBoatService.placedShips$.subscribe(placedShips => {
      this.placedShips = placedShips;
    }));
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
  
  saveBattleBoat = async () => {
    const shipData: ShipData[] = this.placedShips.map((b: any) => {
      const x = Math.round((b.position.x - DefaultConfBattleBoat.offsetXPosition) / DefaultConfBattleBoat.cellSize);
      const y = Math.round(b.position.y / DefaultConfBattleBoat.cellSize);
      return {
        ShipType: ShipTypeObj[b.id], 
        ShipSize: b.size,
        StartColumn: x,
        StartRow: y,
        IsVertical: +(b.orientation === 'vertical'), 
      }
    });
  
    const data = {
      challengeType: this.gameType,
      ships: shipData,
    };
  
    if(this.confirmingChallenge) {
      this.updateShowInviteConfirmation.emit(true);
      this.onAcceptChallenge.emit(data);
    } else {
      this.setCreatingBattle.emit();
      const logins = Object.entries(this.selectedInvites).flatMap(([key, value]) => value ? key: []);
      const challengeData = await this.challengeBattleBoatService.createChallenge({
        challengeType: this.gameType,
        invitees: logins,
        ruleID: this.selectedInterval,
        ships: shipData,
        startDate: this.selectedStartDate.toLocaleDateString('en-US'),
        wager: this.wagerAmount
      });
      this.setDefaultValuesAfterSaveBattleBoat.emit(challengeData);
    }
    this.resetBoard()
  }

  goBackFn = () => {
    this.goBack.emit();
  }

}
